'use client';

import Link from 'next/link';
import { ArrowLeft } from 'lucide-react';

export default function PrivacidadePage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white">
      <div className="container mx-auto px-4 py-12 max-w-3xl">
        {/* Voltar */}
        <Link 
          href="/" 
          className="inline-flex items-center gap-2 text-gray-400 hover:text-white mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Voltar
        </Link>

        {/* Banner preliminar */}
        <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-4 mb-8">
          <p className="text-yellow-400 text-sm">
            📋 Este documento é preliminar e será atualizado com a versão final antes do lançamento oficial.
          </p>
        </div>

        <h1 className="text-3xl font-bold mb-8">Política de Privacidade</h1>
        
        <div className="prose prose-invert prose-gray max-w-none space-y-6">
          <p className="text-gray-300">
            Última atualização: Janeiro de 2026
          </p>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. Introdução</h2>
            <p className="text-gray-300">
              O Atende Turbo respeita sua privacidade e está comprometido em proteger seus dados pessoais. 
              Esta política explica como coletamos, usamos e protegemos suas informações.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. Dados que Coletamos</h2>
            <p className="text-gray-300">Coletamos os seguintes tipos de dados:</p>
            <ul className="list-disc list-inside text-gray-300 mt-2 space-y-1">
              <li><strong>Dados da conta:</strong> nome, email, telefone</li>
              <li><strong>Dados do WhatsApp:</strong> mensagens processadas para gerar respostas automáticas</li>
              <li><strong>Dados de uso:</strong> logs de acesso e métricas de uso</li>
              <li><strong>Dados de pagamento:</strong> processados pelo Stripe (não armazenamos cartões)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Como Usamos seus Dados</h2>
            <p className="text-gray-300">Utilizamos seus dados para:</p>
            <ul className="list-disc list-inside text-gray-300 mt-2 space-y-1">
              <li>Fornecer e melhorar nossos serviços</li>
              <li>Treinar a IA para responder como você (apenas com seus dados)</li>
              <li>Enviar comunicações sobre sua conta</li>
              <li>Processar pagamentos</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Compartilhamento de Dados</h2>
            <p className="text-gray-300">
              Não vendemos seus dados. Compartilhamos apenas com:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2 space-y-1">
              <li><strong>Provedores de IA:</strong> OpenAI/Anthropic para processamento de mensagens</li>
              <li><strong>Infraestrutura:</strong> Supabase (banco de dados), Vercel (hospedagem)</li>
              <li><strong>Pagamentos:</strong> Stripe</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Segurança</h2>
            <p className="text-gray-300">
              Utilizamos criptografia em trânsito (HTTPS) e em repouso. 
              Credenciais de acesso ao WhatsApp são criptografadas com chaves exclusivas por usuário.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">6. Seus Direitos</h2>
            <p className="text-gray-300">
              Você tem direito a acessar, corrigir ou excluir seus dados a qualquer momento. 
              Para exercer esses direitos, entre em contato conosco.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">7. Retenção de Dados</h2>
            <p className="text-gray-300">
              Mantemos seus dados enquanto sua conta estiver ativa. 
              Após cancelamento, os dados são excluídos em até 30 dias.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">8. Contato</h2>
            <p className="text-gray-300">
              Para questões de privacidade: privacidade@atendeturbo.com.br
            </p>
          </section>
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-500 text-sm">
          <p>© 2026 Atende Turbo. Todos os direitos reservados.</p>
        </div>
      </div>
    </div>
  );
}
